// extracted by mini-css-extract-plugin
export var coastalHollywood = "styles-module--coastalHollywood--HzPQK";
export var headerContainer = "styles-module--headerContainer--iDCrb";
export var coastalHollywoodGallery = "styles-module--coastalHollywoodGallery--1qc1P";
export var coastalHollywoodRow = "styles-module--coastalHollywoodRow--ybuJH";